module.exports = __webpack_public_path__ + "static/media/vector.344af47f.svg";